<template>
  <div>
    <v-card>
      <v-card-text>
        <h2><v-icon>contacts</v-icon>Contact details</h2>
        <table cellpadding="3" v-if="entity.contactDetails">
          <tbody
            v-for="(contactDetailType, cdtindex) in entity.contactDetails"
            :key="cdtindex"
          >
            <tr
              v-for="(detail, dindex) in contactDetailType.details"
              :key="dindex"
            >
              <th
                :rowspan="contactDetailType.count"
                style="background: #eeeeee"
                v-if="dindex === 0"
              >
                {{ contactDetailType.detailType.name }}
              </th>
              <td>
                <a :href="`mailto:${detail.body}`" v-if="detail.typeid == 3">{{
                  detail.body
                }}</a>
                <a
                  :href="
                    detail.body.startsWith('http://')
                      ? detail.body
                      : `http://${detail.body}`
                  "
                  v-if="detail.typeid == 5"
                  target="_blank"
                  >{{ detail.body }}</a
                >
                <span v-if="detail.typeid != 3 && detail.typeid != 5">{{
                  detail.body
                }}</span>
              </td>
              <td style="background: #eeeeee">
                <a v-if="!detail.primary" @click="archive(detail)">X</a>
              </td>
              <td>
                <a
                  v-if="allowPrimary && detail.typeid == 3 && !detail.primary"
                  @click="primary(detail)"
                  >Set as primary</a
                >
              </td>
            </tr>
          </tbody>
        </table>
        <v-btn
          @click="
            addContact = true;
            detailType = null;
          "
        >
          <v-icon>add</v-icon>Contact detail
        </v-btn>
        <div class="ajaxForm" v-if="addContact">
          <h2>Add contact detail</h2>
          <template v-if="!detailType">
            <p>Choose the type of contact detail you want to add</p>
            <ul>
              <li v-for="dt in detailTypes" :key="dt.id">
                <a @click="loadSuggestions(dt)">{{ dt.name }}</a>
              </li>
            </ul>
            <hr />
            <v-btn @click="addContact = false">Cancel</v-btn>
          </template>
          <template v-if="detailType">
            <template v-if="suggestions && suggestions.length > 0">
              <p>Suggestions taken from quotation:</p>
              <ul>
                <li v-for="(suggestion, sindex) in suggestions" :key="sindex">
                  <a
                    @click="
                      value = suggestion;
                      save;
                    "
                    >{{ suggestion }}</a
                  >
                </li>
              </ul>
            </template>
            <v-form ref="contactDetailForm">
              <p>Enter the detail below and click save</p>
              <v-text-field
                :label="detailType.name"
                v-model="value"
                :rules="detailType.id == 3 ? emailRules : valueRules"
              />
              <v-btn @click="save"> <v-icon>save</v-icon>Save </v-btn>
              <v-btn @click="addContact = false">Cancel</v-btn>
            </v-form>
          </template>
        </div>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ENTITY_CONTACT_DETAIL_TYPE_SUGGESTIONS from "@/graphql/directory/EntityContactDetailTypeSuggestions";
import DETAIL_TYPES from "@/graphql/directory/DetailTypes";
import UPDATE_ENTITY_DETAIL_BY_TYPE from "@/graphql/directory/UpdateEntityDetailByType";
import UPDATE_ENTITY_DETAIL_ARCHIVED from "@/graphql/directory/UpdateEntityDetailArchived";
import UPDATE_ENTITY_DETAIL_PRIMARY from "@/graphql/directory/UpdateEntityDetailPrimary";
import emailValidator from "email-validator";
export default {
  name: "Contact",
  props: ["entity", "lastUpdated"],
  apollo: {
    detailTypes: {
      query: DETAIL_TYPES,
      variables() {
        return {
          kind: 1
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    allowPrimary() {
      return (
        (this.entity && this.entity.typeid != 2) ||
        this.$keycloak.hasRealmRole("root")
      );
    }
  },
  data() {
    return {
      addContact: false,
      detailType: null,
      suggestions: null,
      value: null,
      valueRules: [(v) => !!v || "Value is required"],
      emailRules: [
        (v) => {
          if (!v) {
            return "Email address is required";
          }
          return emailValidator.validate(v) || "Invalid e-mail.";
        }
      ],
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async save() {
      if (this.$refs.contactDetailForm.validate()) {
        await this.$apollo.mutate({
          mutation: UPDATE_ENTITY_DETAIL_BY_TYPE,
          variables: {
            id: Number(this.$route.params.id),
            typeid: this.detailType.id,
            value: this.value
          }
        });
        // console.log(response.data);
        this.addContact = false;
        this.value = null;
        this.$emit("triggerUpdate");
      }
    },
    async loadSuggestions(detailType) {
      const response = await this.$apollo.query({
        query: ENTITY_CONTACT_DETAIL_TYPE_SUGGESTIONS,
        variables: {
          id: Number(this.$route.params.id),
          detailTypeId: detailType.id
        }
      });
      // console.log(response.data);
      this.suggestions = response.data.entity.contactDetailTypeSuggestions;
      this.detailType = detailType;
    },
    async archive(detail) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: UPDATE_ENTITY_DETAIL_ARCHIVED,
          variables: {
            id: Number(this.$route.params.id),
            detailid: detail.id,
            archived: true
          }
        });
        // console.log(response.data);
        this.$emit("triggerUpdate");
      }
    },
    async primary(detail) {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_ENTITY_DETAIL_PRIMARY,
          variables: {
            id: Number(this.$route.params.id),
            detailid: detail.id
          }
        });
        this.$emit("triggerUpdate");
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err;
      }
    }
  }
};
</script>
